/* ***************************************************************************
------------------------------ Focus/Blur Input ------------------------------
*************************************************************************** */
(function($){
    
    var targetForm;
    var valueForm;
    $(document).on("focus",".content-form input, .content-form textarea, .content-form select", function(){
        targetForm = $(this).parents('.over-input:first');
        valueForm = $(this).val();

        if(targetForm.hasClass('over-input')){
            targetForm.addClass('active');
            targetForm.removeClass('not-empty');
        }
	});

    $(document).on("blur",".content-form input, .content-form textarea, .content-form select", function(){
        targetForm = $(this).parents('.over-input:first');
        valueForm = $(this).val();

        if(valueForm != ''){
            targetForm.addClass('not-empty');
        }

        if(targetForm.hasClass('over-input')){
            targetForm.removeClass('active');
        }
    });

    var el = $(".content-form input, .content-form textarea");
    if (el.length){
        el.each(function(i,input){
            if ($(input).val().length){
                $(input).addClass('not-empty').blur();
            }
        });
    }
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/modules/focus-input.js